<!-- Zone 1 redesign (29/10/2026): an icon says « location » before a word
     is read, and the way out is a real button rather than one blue line among
     two, so the person sees which tap fixes the problem. -->
<div class="device-location-off-alert">
  <div class="device-location-off-alert__badge" aria-hidden="true">
    <ion-icon name="navigate-outline"></ion-icon>
  </div>
  <h2 class="device-location-off-alert__title">
    {{ titleKey | translate }}
  </h2>
  <p class="device-location-off-alert__message">
    {{ messageKey | translate }}
  </p>
  <div class="device-location-off-alert__actions">
    <button
      type="button"
      class="device-location-off-alert__action device-location-off-alert__action--primary"
      (click)="openSettings()"
    >
      {{ 'LOCATION_PERMISSION_MODAL.OPEN_SETTINGS' | translate }}
    </button>
    <button type="button" class="device-location-off-alert__action" (click)="later()">
      {{ 'LOCATION_PERMISSION_MODAL.LATER' | translate }}
    </button>
  </div>
</div>
